module.exports = __webpack_public_path__ + "66b8b86b215d1389edca663340028a34.jpg";